<template>
  <div>
    <!-- 詢價單編輯主畫面 -->
    <CCard class="w-100">
      <CCardHeader class="header_group">
        <strong>{{ headerText }}</strong>
      </CCardHeader>
      <CCardBody>
        <CNavbar light color="light">
          <CForm>
            <div class="CForminline">
              <div class="date">
                <p>
                  {{ $t("QuoteInfo_Vue.StartDate") }}：{{ form.createTime }}
                </p>
              </div>
              <div class="factory">
                <p>{{ $t("QuoteInfo_Vue.FactoryType") }}：</p>
                <div
                  v-for="(item, key) in factoryList"
                  :key="'factory_input_' + key"
                >
                  <input
                    type="radio"
                    v-model="form.factoryId"
                    :value="item.factoryId"
                    disabled
                  />{{ item.factoryCaption }} ({{ item.factoryId }})
                </div>
              </div>
              <div class="quoteNo">
                <p>{{ $t("Request_Vue.QuoteNo") }}： {{ form.inquiryNo }}</p>
              </div>
              <div class="creator">
                <p>{{ $t("Request_Vue.Version") }}： {{ form.version }}</p>
              </div>
              <div class="inquiry_name">
                <p>
                  {{ $t("Request_Vue.InquiryName") }}：{{ form.inquiryName }}
                </p>
              </div>
              <div class="inquiry_name">
                <p>{{ $t("Request_Vue.Currency") }}：{{ form.currency }}</p>
              </div>
              <div class="inquiry_name">
                <p>
                  {{ $t("Request_Vue.Deadline") }}：{{ form.inquiryEndDate }}
                </p>
              </div>
              <div class="inquiry_name">
                <p>
                  {{ $t("Request_Vue.Purchaser") }}：{{ form.purchaseName }}
                </p>
              </div>

              <div class="inquiry_name" style="align-items: start;">
                <p>
                  {{ $t("Request_Vue.SupplierRemark") }}：
                </p>
                <span style="white-space: pre-line;">{{ form.supplierMemo }}</span>
              </div>
            </div>
          </CForm>
        </CNavbar>
      </CCardBody>
    </CCard>

    <CCard class="w-100">
      <div class="mt-4">
        <div class="text-right mb-2">
          <button
            type="button"
            class="btn btn-success mr-2"
            @click="quoteFileModal(form)"
            v-if="form.status === '廠商報價中'"
          >
            {{ i18n("Buttons.Upload")
            }}{{ i18n("QuoteInfo_Vue.QuotationAttachment") }}
          </button>
          <button
            type="button"
            class="btn btn-warning mr-2"
            @click="quoteFileModal(form)"
            v-else
          >
            {{ i18n("Buttons.Quote") }}{{ i18n("Buttons.Attachments") }}
          </button>
        </div>

        <table class="table">
          <thead class="thead-light">
            <tr>
              <th
                class="text-center"
                v-for="header in tableHeader"
                :key="header"
              >
                {{ header }}
              </th>
              <th class="text-center">
                {{ i18n("PurchaseInfoTableHeader.Function") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in form.requestDetails" :key="item.id">
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center">{{ item.productName }}</td>
              <td class="text-center">{{ item.spec }}</td>
              <td class="text-center">{{ item.material }}</td>
              <td class="text-center">{{ item.brand }}</td>
              <td class="text-center">{{ item.productNo }}</td>
              <td class="text-center">{{ item.color }}</td>
              <td class="text-center">{{ item.quantity }}</td>
              <td class="text-center">
                <button
                  type="button"
                  class="btn btn-warning"
                  @click="requireFileModal(item)"
                >
                  {{ i18n("Buttons.Attachments") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </CCard>

    <div class="fixed-bottom">
      <button
        class="btn btn-info mb-3"
        @click="saveAll"
        v-if="form.status === '廠商報價中'"
      >
        {{ $t("Buttons.SavedData") }}
      </button>
      <button class="btn btn-dark" to="" @click="goBack">
        {{ $t("Buttons.GoBack") }}
      </button>
    </div>

    <!-- 報價附件 Modal -->
    <div
      class="modal fade"
      id="quoteFileModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ i18n("Buttons.Quote") }}{{ i18n("Buttons.Attachments") }}
          </div>
          <div class="modal-body">
            <el-form :model="quoteFileForm" ref="quoteFileForm">
              <el-form-item label="上傳檔案" prop="Upload">
                <el-upload
                  class="upload-demo"
                  accept=".gif,.png,.jpg,.doc,.xls,.ppt,.docx,.xlsx,.pptx,.pdf"
                  action
                  multiple
                  :file-list="fileQuote"
                  :on-change="changeUploadQuote"
                  :auto-upload="false"
                  :on-preview="downloadQuote"
                  :on-remove="removeQuote"
                  :disabled="form.status !== '廠商報價中'"
                >
                  <el-button
                    size="small"
                    type="warning"
                    plain
                    v-if="form.status === '廠商報價中'"
                    >{{ i18n("Buttons.SelectFile") }}</el-button
                  >
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="saveQuoteFile()"
              v-if="form.status === '廠商報價中'"
            >
              {{ i18n("Buttons.SavedData") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 需求附件 Modal -->
    <div
      class="modal fade"
      id="requireFileModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">{{ $t("Buttons.Attachments") }}</div>
          <div class="modal-body">
            <el-form :model="requireFileForm" ref="requireFileForm">
              <el-upload
                class="upload-demo"
                action
                :file-list="fileRequire"
                :auto-upload="false"
                :on-preview="downloadRequire"
                disabled
              >
              </el-upload>
            </el-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("Buttons.Cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Notification } from "element-ui";
import $ from "jquery";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // isEdit: true,
      // isDisabled: true,
      tableHeader: [
        // 表格標題
        this.i18n("Request_Vue.No"),
        this.i18n("Request_Vue.ProductName"),
        this.i18n("Request_Vue.Specification"),
        this.i18n("Request_Vue.Material"),
        this.i18n("Request_Vue.Brand"),
        this.i18n("Request_Vue.Type"),
        this.i18n("Request_Vue.Color"),
        this.i18n("Request_Vue.Quantity"),
      ],

      factoryList: this.$t("factoryListForPurchase"), //廠別 清單

      form: {},
      requireFileForm: {}, // 需求附件Form
      quoteFileForm: {}, // 報價附件Form
      fileRequire: [], //需求附件
      fileQuote: [], //報價附件
    };
  },
  props: {
    formData: {
      type: Object,
    },
  },
  components: {},
  computed: {
    ...mapGetters(["lang"]),
    headerText() {
      if (this.lang === "en") {
        return "RFQ";
      } else {
        return "詢價單";
      }
    },
  },
  methods: {
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    // 返回
    goBack() {
      this.$router.back();
      // const self = this;
      // if (self.isView) {
      //   self.actionGoBack();
      //   return;
      // }
      // if (!self.isMember && !this.isContentOnlyView) {
      //   if (self.isEdit) {
      //     const row = self.quoteRow;
      //     if (!row.fileName && !row.addFiles) {
      //       this.$alert("無上傳附件檔案，不允許返回!", "警告", {
      //         type: "warning",
      //       });
      //       return;
      //     }
      //   }
      // }
      // this.$confirm("尚未儲存變更的資料，您確定要離開目前的網頁嗎？", "提示", {
      //   confirmButtonText: "是",
      //   cancelButtonText: "否",
      //   type: "warning",
      // })
      //   .then(() => {
      //     self.actionGoBack();
      //   })
      //   .catch(() => {
      //     //console.log("放棄了");
      //   });
    },
    // actionGoBack() {
    //   if (!this.isView) {
    //     const param = {
    //       guid: this.guid,
    //       requestType: this.quoteRow.requestType,
    //     };
    //     if (param.guid && param.requestType) {
    //       //清除，可能上傳匯入的 Excel 資料
    //       const url = `${this.$apiUrl_Quotation}/CancelQuoteData`;
    //       this.axios.post(url, param).then(() => {});
    //     }
    //   }
    //   this.$router.push("/suppliersearchlist");
    // },

    // 取得 詢價單 Detail Api
    getDetail(guid) {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/RequestDetail`;
      this.updateLoading(true);

      let params = {
        RequestMasterId: guid,
        VendorId: this.$userInfo.vendorId,
      };

      this.axios.get(api, { params }).then((response) => {
        // console.log("詢價單", response);
        let createTime = response.data.createTime.split("T");
        let inquiryEndDate = "";
        if (response.data.inquiryEndDate) {
          let date = response.data.inquiryEndDate.split("T");
          inquiryEndDate = date[0];
        } else {
          inquiryEndDate = null;
        }

        vm.form = {
          ...response.data,
          createTime: createTime[0],
          inquiryEndDate: inquiryEndDate,
        };

        if (vm.form.requestSupplierFiles === null) {
          vm.form.requestSupplierFiles = [];
        }

        this.updateLoading(false);
      });
    },

    ///////////////////////////////   需求附件   ///////////////////////////////
    // 需求附件 Modal
    requireFileModal(row) {
      const vm = this;
      vm.fileRequire = [];
      // console.log("requestDetails", row);

      if (row.requestDetailFiles && row.requestDetailFiles.length > 0) {
        vm.fileRequire = row.requestDetailFiles.map((item) => {
          return {
            name: item.fileName ? item.fileName : null,
            id: item.id ? item.id : null,
          };
        });
      } else {
        vm.fileRequire = [];
      }
      $("#requireFileModal").modal("show");
    },
    // 下載檔案 依檔案guid取得檔案 Api
    downloadRequire(file) {
      // console.log(file);
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/GetFile/${file.id}`;

      vm.axios.get(api, { responseType: "blob" }).then((response) => {
        const filename = decodeURIComponent(
          decodeURIComponent(
            response.headers["content-disposition"].split(
              "filename*=UTF-8''"
            )[1]
          )
        );
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },

    ///////////////////////////////   報價附件   ///////////////////////////////
    // 報價附件 Modal
    quoteFileModal(form) {
      const vm = this;
      vm.fileQuote = [];
      if (form.requestSupplierFiles && form.requestSupplierFiles.length > 0) {
        vm.fileQuote = form.requestSupplierFiles.map((item) => {
          return {
            name: item.fileName ? item.fileName : null,
            id: item.id ? item.id : null,
          };
        });
      } else {
        vm.fileQuote = [];
      }
      $("#quoteFileModal").modal("show");
    },
    // 儲存上傳檔案 Api
    saveQuoteFile() {
      const vm = this;

      if (vm.fileQuote.length > 0) {
        vm.fileQuote.forEach((file) => {
          let formData = new FormData();
          if (file.raw) {
            formData.append(`file`, file.raw);

            const api = `${this.$baseApiUrl}/RequestSupplier/UploadRequestSupplier`;
            vm.updateLoading(true);

            this.axios
              .post(api, formData, {
                headers: { "Content-Type": "multipart/form-data" },
              })
              .then((response) => {
                // console.log("upload", response);
                if (response.status === 200) {
                  vm.form.requestSupplierFiles.push({
                    fileName: file.name,
                    id: response.data,
                  }); //  將回傳的Guid 存入要送出的資料裡

                  this.updateLoading(false);
                  $("#quoteFileModal").modal("hide");
                } else {
                  this.updateLoading(false);
                  Notification({
                    title: "錯誤",
                    message: response.data.errorMessage,
                    type: "error",
                    duration: 5000,
                  });
                }
              });
          } else {
            $("#quoteFileModal").modal("hide");
          }
        });
      } else {
        $("#quoteFileModal").modal("hide");
      }
    },
    // 上傳檔案 Fun
    changeUploadQuote(file) {
      const vm = this;
      vm.fileQuote.push(file);
    },
    // 下載檔案 依檔案guid取得檔案 Api
    downloadQuote(file) {
      const vm = this;
      if (file.id) {
        const api = `${this.$baseApiUrl}/RequestSupplier/GetFile/${file.id}`;

        vm.axios.get(api, { responseType: "blob" }).then((response) => {
          const filename = decodeURIComponent(
            decodeURIComponent(
              response.headers["content-disposition"].split(
                "filename*=UTF-8''"
              )[1]
            )
          );
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        });
      } else {
        this.$alert("未儲存附件無法下載", "提示", { type: "warning" });
      }
    },
    // 刪除檔案 Api
    removeQuote(file) {
      const vm = this;
      if (file.id) {
        // 執行順序問題 需let index 才可以刪到一樣的位置
        let index = vm.fileQuote.findIndex((e) => e.id === file.id);
        vm.fileQuote.splice(index, 1);
        vm.form.requestSupplierFiles.splice(index, 1);
      } else {
        vm.fileQuote.splice(
          vm.fileQuote.findIndex((e) => e.uid === file.uid),
          1
        );
      }
    },

    // 儲存 Api
    saveAll() {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestSupplier/SaveRequestSupplierFile`;

      let requestSupplierFiles = vm.form.requestSupplierFiles.map((item) => {
        return item.id;
      });

      const param = {
        requestMasterId: vm.form.id,
        VendorId: this.$userInfo.vendorId,
        requestSupplierFiles: requestSupplierFiles,
      };

      if (
        !(param.requestSupplierFiles && param.requestSupplierFiles.length > 0)
      ) {
        this.$alert("必須要有報價附件", "警告", { type: "warning" });
      } else {
        this.updateLoading(true);

        this.axios.post(api, param).then((response) => {
          // console.log("sendRequest", response);
          if (response.data.errorMessage) {
            this.updateLoading(false);
            Notification({
              title: "錯誤",
              message: response.data.errorMessage[0],
              type: "error",
              duration: 5000,
            });
          } else {
            this.updateLoading(false);
            Notification({
              title: "成功",
              message: "送出成功",
              type: "success",
              duration: 5000,
            });

            this.$router.push({
              path: "/suppliersearchlist",
            });
          }
        });
      }
    },
  },
  mounted() {
    const vm = this;
    vm.getDetail(vm.formData.requestMasterId);
  },
  watch: {
    lang: function () {
      this.tableHeader = [
        this.i18n("Request_Vue.No"),
        this.i18n("Request_Vue.ProductName"),
        this.i18n("Request_Vue.Specification"),
        this.i18n("Request_Vue.Material"),
        this.i18n("Request_Vue.Brand"),
        this.i18n("Request_Vue.Type"),
        this.i18n("Request_Vue.Color"),
        this.i18n("Request_Vue.Quantity"),
      ];

      this.factoryList = this.$t("factoryListForPurchase"); //廠別 清單
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '~bootstrap/scss/bootstrap.scss';
@import "@/assets/scss/select.scss";

.table tr:nth-child(even) {
  background-color: transparent;
}

.btn-edit {
  background-color: #343b55;
  color: white;
}
.filter-btn-wrap {
  margin-top: 21px;
}
.option {
  margin-left: 0.2rem;
  cursor: pointer;
}
.item_list {
  margin-bottom: 5px;
}
.item-select #left-item .item-list .item,
.item-select #right-item .item-list .item {
  display: flex;
  align-items: center;
}
.item-select #left-item .item-list .item input[type="checkbox"],
.item-select #right-item .item-list .item input[type="checkbox"] {
  display: block;
  margin-right: 0.5rem;
}

table th:first-child {
  text-align: center;
  padding: 15px 5px;
}

.btn-secondary {
  color: #fff;
  background-color: gray;
}

.header_group {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header_group button {
  margin-left: 8px;
}
.CForminline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  > .quoteNo,
  .factory,
  .date,
  .creator,
  .extension,
  .applicant_unit,
  .inquiry_name,
  .purchaser,
  .status_code,
  .demand_purpose,
  .demand_date,
  .engineer_name,
  .engineer_mail,
  .review,
  .supplier,
  .currency,
  .ask_merchant,
  .deadline {
    display: flex;
    align-items: center;
    margin: 0.5rem 0;

    > p {
      margin-right: 1rem;
      margin-bottom: 0;
    }

    > input {
      margin: 0 0.5rem;
    }

    > span {
      margin: 0 0.5rem;
    }

    > div {
      margin: 0 0.5rem;
    }
  }

  > .purchase_info {
    > p:first-child {
      margin: 0;
    }
    > p {
      margin: 0 0.5rem;
    }
  }
}

.factory_group,
.class {
  > input[type="radio"] {
    margin-left: 0.5rem;
  }
}

.fixed-bottom {
  left: auto;
  right: 10px;
  bottom: 10%;

  > .btn {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.btn-warning {
  color: #fff;
}
</style>